/* eslint-disable max-len */
import EaSasIcon1 from '@propertypal/shared/src/resources/icons/products/ea-competitors-icon.svg';
import EaSasIcon2 from '@propertypal/shared/src/resources/icons/products/ea-consultancy-icon.svg';
import EaSasIcon3 from '@propertypal/shared/src/resources/icons/products/ea-profile-icon.svg';
import Sas from '@propertypal/shared/src/resources/icons/products/ea-sponsor-search-icon.svg';
import SasMockup from '@propertypal/shared/src/resources/images/sponsor-a-search/ea-sas-mockup.png';
import ProductsPageHeader, { ProcutsHeaderIcon } from '@propertypal/web-ui/src/headers/products/ProductsPageHeader';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import ProductScreenTabs, { ProductScreenTab } from '@propertypal/web-ui/src/products/ProductScreenTabs';
import SponsorSearchFeatures from '@propertypal/web-ui/src/products/SponsorSearchFeatures';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Developers Sponsor a Search - PropertyPal',
  description: 'Claim Exclusive Advertising Power For Your New Development In A Prime Location Of Your Choice.',
  url: `/products/developers/sponsor-a-search`,
};

const tabs: ProductScreenTab[] = [
  {
    title: 'Takeover a town',
    text: `Your brand and message takes over the full top section of the search results page in your chosen location.`,
    maxW: 420,
  },
  {
    title: 'Exclusive advertising power',
    text: `Display your message and brand in a permanent spot, in a prime location of your choice, for the duration of your campaign.`,
    maxW: 330,
  },
  {
    title: 'Maximise exposure',
    text: `Showcase your brand and key message in front of thousands of potential buyers.`,
    maxW: 320,
  },
];

const icons: ProcutsHeaderIcon[] = [
  {
    SVG: EaSasIcon1,
    heading: 'Gain the edge on your competitors',
    headingMaxW: 180,
    headingSize: 20,
    headingMt: 25,
  },
  {
    SVG: EaSasIcon2,
    heading: 'Win new instructions and grow your business',
    headingMaxW: 240,
    headingSize: 20,
    headingMt: 25,
  },
  {
    SVG: EaSasIcon3,
    heading: 'Raise the profile of your brand in key areas',
    headingMaxW: 240,
    headingSize: 20,
    headingMt: 25,
  },
];

const DeveloperSponsorASearch = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsPageHeader
        title="Sponsor a Search"
        text="Claim exclusive advertising power for your new development in a prime location of your choice"
        headingProps={{ mb: 10 }}
        subHeadingProps={{ maxWidth: 970 }}
        icon={<Sas />}
        icons={icons}
        iconsColumnGap={100}
      />
      <ProductScreenTabs
        tabs={tabs}
        aspectRatio="559 / 337"
        mockupWidth={700}
        negMargin={70}
        maxW={1200}
        breakpoint={1200}
        tabsMt={-15}
        reverse
        pb={110}
        button={{
          onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
          text: 'Contact us',
          containerStyle: { maxWidth: '280px' },
        }}
        mockup={SasMockup}
        staticTabs
        buttonXPadding={20}
      />
      <SponsorSearchFeatures dev />
      <ProductsContact reason="Developers Sponsor a Search" />
    </>
  );
};

export default DeveloperSponsorASearch;
